/** @format */

export const head = ([a]) => a
